<template>
    <div class="blank-layout bg-gray-100 vh-100 flex-grow-1 d-flex flex-column">
        <slot></slot>
    </div>
</template>
